module.exports = __webpack_public_path__ + "img/trial4-4.e648289f.png";